import React from "react";
import { Alert, Button } from "@mui/material";
import { useAuth } from "../../../../contexts/AuthContext";
import { recordsService } from "../../../../api/services/records";
import { refreshRecords } from "../../../../hooks/useRemote";
import useMutation from "../../../../hooks/useMutation";

export default function StudentStatus({ student, refresh }) {
  const { user } = useAuth();
  const mutation = useMutation();
  if (user?.role !== "superuser" || !student?.username) return null;
  const change = async (reason) => {
    const result = await mutation.run((signal) => recordsService.status(student.username, reason, signal));
    if (result) { refresh(); refreshRecords(); }
  };
  return <section className="rounded-panel border border-rule bg-surface p-xl space-y-4">
    <h2>وضعیت رسمی دانش‌آموز: {student.studentuser?.student_status || student.student_status || (student.is_active ? "فعال" : "غیرفعال")}</h2>
    {mutation.error && <Alert severity="error">{mutation.error}</Alert>}
    {mutation.result && <Alert severity="success">{mutation.result.message || "وضعیت ثبت شد."}</Alert>}
    {["انصراف", "اخراج"].map((reason) => <Button key={reason} color="warning" disabled={mutation.disabled} onClick={() => change(reason)}>{reason}</Button>)}
    <Button disabled={mutation.disabled} onClick={() => change(null)}>بازگردانی دانش‌آموز</Button>
  </section>;
}
